// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bC9b","tabsBox":"styles_tabsBox__35L3A","createButton":"styles_createButton__8PIFF"};